import { EventProductMappedToTier } from 'legacy/common/types/models';
import isTierAvailable from './isTierAvailble';

/**
 * Finds a tier by its ID from a list of mapped products to tiers.
 */
export const findTier = (
  mappedProductsToTiers: EventProductMappedToTier[],
  tierId: string
) => mappedProductsToTiers.find((tier) => tier._id === tierId);

/**
 * Checks if a code is already active in the private tier codes.
 */
export const isCodeAlreadyActive = (
  privateTierCodes: Record<string, string>,
  code: string
) => Object.values(privateTierCodes).includes(code);

/**
 * Checks if a tier requires approval and is not yet approved.
 */
export const isTierRequiringApproval = (
  mappedProductsToTiers: EventProductMappedToTier[],
  tierId: string
) => {
  const tier = findTier(mappedProductsToTiers, tierId);
  return tier?.requiresApproval && tier?.requestStatus !== 'approved';
};

/**
 * Checks if a tier is disabled based on various conditions.
 */
export const isTierDisabled = (
  mappedProductsToTiers: EventProductMappedToTier[],
  tierId: string
) => {
  const tier = findTier(mappedProductsToTiers, tierId);
  return Boolean(
    tier &&
      (tier.isDisabled ||
        !isTierAvailable(tier) ||
        tier.requestStatus === 'pending' ||
        tier.requestStatus === 'rejected' ||
        tier.status === 'max')
  );
};
